import React from "react";
import Moment from "react-moment";
import { Link } from "gatsby";
import styled from "@emotion/styled";
import dimensions from "styles/dimensions";
import colors from "styles/colors";
import PropTypes from "prop-types";

const PostCardContainer = styled(Link)`
  border: 1px solid #eaeaea;
  padding: 0 0 3.5rem 0;
  border-radius: 4px;
  text-decoration: none;
  color: currentColor;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.06);
  transition: all 150ms ease-in-out;
  position: relative;
  align-content: flex-start;

  &:hover {
    box-shadow: 0px 9px 24px rgba(0, 0, 0, 0.1);
    transition: all 150ms ease-in-out;
    cursor: pointer;

    .PostCardAction {
      color: ${colors.accent};
      transition: all 150ms ease-in-out;

      span {
        transform: translateX(0px);
        opacity: 1;
        transition: transform 150ms ease-in-out;
      }
    }
  }
`;

const PostHeroContainer = styled("div")`
  display: flex;
  overflow: hidden;
  align-items: center;
  height: 220px;
  background-size: cover;
  background-position: center;
  margin-bottom: 1rem;
  border-radius: 3px 3px 0 0;
  width: 100%;
  @media (max-width: ${dimensions.maxwidthTablet}px) {
    height: 180px;
  }
  @media (max-width: ${dimensions.maxwidthMobile}px) {
    height: 400px;
  }
  @media (max-width: ${dimensions.maxwidthPhone}px) {
    height: 280px;
  }
`;

const PostTitle = styled("h3")`
  margin: 0;
  width: 100%;
  padding: 0 2rem 0.5rem;
  @media (max-width: ${dimensions.maxwidthTablet}px) {
    font-size: 1.6rem;
  }
`;

const PostMetas = styled("div")`
  display: flex;
  padding: 0 1.8rem;
  align-items: center;
  margin-top: 1rem;
  justify-content: space-between;
  font-size: 1.4rem;
  color: ${colors.grey600};
  width: 100%;
  position: absolute;
  bottom: 1.5rem;
`;

const PostDate = styled("div")`
  margin: 0;
  width: auto;
  font-size: 1.2rem;
`;

const PostDescription = styled("div")`
  padding: 0 2rem 2rem;
  width: 100%;
  @media (max-width: ${dimensions.maxwidthTablet}px) {
  }

  p:last-of-type {
    margin: 0;
  }
`;

const PostCardAction = styled("div")`
  font-weight: 600;
  text-decoration: none;
  color: currentColor;
  transition: all 150ms ease-in-out;

  span {
    margin-left: 1rem;
    transform: translateX(-8px);
    display: inline-block;
    transition: transform 400ms ease-in-out;
  }
`;

const PostCard = ({ date, title, description, uid, image }) => (
  <PostCardContainer className="BlogPostCard" to={`/${uid}`}>
    <PostHeroContainer
      style={{ backgroundImage: `url(${image.url})` }}
    ></PostHeroContainer>
    <PostTitle>{title[0].text}</PostTitle>
    <PostDescription>
      {description[0].text.substring(0, 140)}...
    </PostDescription>
    <PostMetas>
      <PostDate>
        <Moment format="MMMM D, YYYY">{date}</Moment>
      </PostDate>
      <PostCardAction className="PostCardAction">
        Read more <span>&#8594;</span>
      </PostCardAction>
    </PostMetas>
  </PostCardContainer>
);

export default PostCard;

PostCard.propTypes = {
  date: PropTypes.string.isRequired,
  title: PropTypes.array.isRequired,
  description: PropTypes.array.isRequired,
  uid: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
};
